import React from 'react'
import R from 'ramda'
import {
  Label
} from 'semantic-ui-react'

import { escapeRE } from '_utils'

import Gravatar from '_views/gravatar'
import SuggestionItem from '_views/suggestionItem'
import SuggestionItems from '_views/suggestionItems'
import searchHOC from '_forms/searchHOC'

const getDisplay = R.prop('displayname')
const getEmail = R.prop('email')
const getId = R.prop('_id')
const getUsername = R.prop('username')
const getFullName = R.prop('full_name')
const getDescription = R.prop('description')
// these all need filtering
const getFsRef = R.compose(
  R.split(' '),
  R.defaultTo(''),
  R.path(['activated_info', 'fastspring', 'reference'])
)
const getFsSubRef = R.path(['activated_info', 'fastspring', 'subscription', 'reference'])
const getFsFullName = R.path(['activated_info', 'fastspring', 'customer', 'full_name'])
const getFsEmail = R.path(['activated_info', 'fastspring', 'customer', 'email'])
const getFsMax6Sn = R.path(['activated_info', 'fastspring', 'surveys', 'max6_serial'])
const getFsMFLSn = R.path(['activated_info', 'fastspring', 'surveys', 'max4live_serial'])
const getLicSn = R.path(['activated_info', 'serial_id'])
const getAc = R.path(['activated_info', 'ac_id'])
const getNote = R.prop('note')

const getLics = R.compose(
  R.defaultTo([]),
  R.prop('licenses')
)
const getNotes = R.compose(
  R.defaultTo([]),
  R.prop('notes')
)

const formatSelection = user => {
  const _id = R.prop('_id', user)
  const display = R.prop('displayname', user)
  const email = R.prop('email', user)
  return (
    <Label style={{display: 'inline-block'}} key={'sel_' + _id}>
      <div>{ display }</div>
      <div>{ email }</div>
      <div><small>{ _id }</small></div>
    </Label>
  )
}

const formatSuggestion = (user, term) => {
  const tReg = {
    regex: new RegExp(escapeRE(term), 'i'),
    term
  }
  return (
    <div key={'sug_' + user._id} >
      <Gravatar gravatar={R.prop('gravatar', user)} size={30} floated='left' circular />

      <SuggestionItem label='email' text={getEmail(user)} tReg={tReg} always={true} />
      <SuggestionItem label='display' text={getDisplay(user)} tReg={tReg} always={true} />

      <SuggestionItem label='id' text={getId(user)} tReg={tReg} />

      <SuggestionItem label='username' text={getUsername(user)} tReg={tReg} />
      <SuggestionItem label='description' text={getDescription(user)} tReg={tReg} />
      <SuggestionItem label='name' text={getFullName(user)} tReg={tReg} />

      <SuggestionItems label='fs ref' list={getLics(user)} pathFn={getFsRef} tReg={tReg} />
      <SuggestionItems label='fs sub ref' pathFn={getFsSubRef} list={getLics(user)} tReg={tReg} />
      <SuggestionItems label='fs name' pathFn={getFsFullName} list={getLics(user)} tReg={tReg} />
      <SuggestionItems label='fs email' pathFn={getFsEmail} list={getLics(user)} tReg={tReg} />
      <SuggestionItems label='fs serial' pathFn={getFsMax6Sn} list={getLics(user)} tReg={tReg} />
      <SuggestionItems label='fs MFL serial' pathFn={getFsMFLSn} list={getLics(user)} tReg={tReg} />
      <SuggestionItems label='serial' pathFn={getLicSn} list={getLics(user)} tReg={tReg} />
      <SuggestionItems label='ac' pathFn={getAc} list={getLics(user)} tReg={tReg} />
      <SuggestionItems label='note' pathFn={getNote} list={getNotes(user)} tReg={tReg} />
    </div>
  )
}

export const { PluralSearch, SingularSearch } = searchHOC({
  icon: 'user',
  placeholder: 'Type to search users...',
  idName: 'userId',
  baseSearchUrl: 'users',
  formatSelection,
  formatSuggestion
})



// WEBPACK FOOTER //
// ./webAdmin/forms/userSearch.js